webpackJsonp([208548178465540],{

/***/ 1566:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"SyncClientInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"identification","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"source","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-sync-client-input-3f729b36edfd66ad509c.js